export default __webpack_public_path__ + "static/media/bg4.c25e7559.png";